import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=b6fa701c&scoped=true"
import script from "./_slug.vue?vue&type=script&lang=js"
export * from "./_slug.vue?vue&type=script&lang=js"
import style0 from "./_slug.vue?vue&type=style&index=0&id=b6fa701c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6fa701c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Toc: require('/workspace/components/Toc.vue').default,RentalSection: require('/workspace/components/RentalSection.vue').default,RentalCardV3: require('/workspace/components/RentalCardV3.vue').default,ActivityCard: require('/workspace/components/ActivityCard.vue').default,ActivityBlog: require('/workspace/components/ActivityBlog/ActivityBlog.vue').default})
